import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InterventionReportComponent} from './intervention-report.component';
import {DxPopupModule, DxTabsModule} from 'devextreme-angular';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {TimePieChartModule} from '../../reports/charts/time-pie-chart/time-pie-chart.module';
import {MapLayersControlModule} from '../../map/map-layers-control/map-layers-control.module';


@NgModule({
  declarations: [InterventionReportComponent],
    imports: [
        CommonModule,
        DxPopupModule,
        LeafletModule,
        TimePieChartModule,
        DxTabsModule,
        MapLayersControlModule,
    ],
  exports: [InterventionReportComponent]
})
export class InterventionReportModule {
}
